export default __webpack_public_path__ + "static/media/bids1.915c4163.png";